import { combineReducers } from '@reduxjs/toolkit'
import applied from './applied'

const compareBy = combineReducers({
  applied,
})

export type CompareBy = ReturnType<typeof compareBy>

export default compareBy
